'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSideNav = exports.getMcpApps = exports.getMenuItems = undefined;

var _mcpapps = require('../config/mcp-header/v3/mcpapps.json');

var _mcpapps2 = _interopRequireDefault(_mcpapps);

var _menuitems = require('../config/mcp-header/v3/menuitems.json');

var _menuitems2 = _interopRequireDefault(_menuitems);

var _sidenav = require('../config/mcp-header/v3/sidenav.json');

var _sidenav2 = _interopRequireDefault(_sidenav);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var HEADER_CONFIG_URL = 'https://static.ux.cimpress.io/mcp-header/v3/';

var getConfigFile = function getConfigFile(filename) {
  try {
    return fetch('' + HEADER_CONFIG_URL + filename, {
      method: 'GET',
      mode: 'cors',
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    }).then(function (response) {
      if (response.status === 200) {
        return response.json();
      } else {
        throw new Error('Non 200 response from static site.');
      }
    });
  } catch (ex) {
    return Promise.reject(ex);
  }
};

var isLocal = function isLocal() {
  return process.env.NODE_ENV === 'docslocal';
};

var handleFailure = function handleFailure(error, fallback) {
  console.error('Error retrieving config file from static site.  using fallback.', error);
  return fallback;
};

var getMenuItems = exports.getMenuItems = function getMenuItems() {
  return isLocal() ? Promise.resolve(_menuitems2.default) : getConfigFile('menuitems.json').catch(function (err) {
    return handleFailure(err, _menuitems2.default);
  });
};

var getMcpApps = exports.getMcpApps = function getMcpApps() {
  return isLocal() ? Promise.resolve(_mcpapps2.default) : getConfigFile('mcpapps.json').catch(function (err) {
    return handleFailure(err, mcpApps);
  });
};

var getSideNav = exports.getSideNav = function getSideNav() {
  return isLocal() ? Promise.resolve(_sidenav2.default) : getConfigFile('sidenav.json').catch(function (err) {
    return handleFailure(err, _sidenav2.default);
  });
};